import { render, staticRenderFns } from "./landingItem.vue?vue&type=template&id=e56e3a56"
import script from "./landingItem.vue?vue&type=script&lang=js"
export * from "./landingItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports